import { VersionedFeatureType } from '../../../../data-access/gql-types/graphql';
import { compareVersions } from '../../../../utils/helpers/versions';
import { useVersionMapStore } from '../../store/version-map';

type SupportPayload = {
  feature: VersionedFeatureType;
  supportKey?: string;
  currentVersion?: string | null;
};

export const useCheckDeviceSupport = () => {
  const versionMap = useVersionMapStore((s) => s.versionMap);

  const checkSupport = ({ feature, supportKey, currentVersion }: SupportPayload) => {
    if (!currentVersion || !supportKey) return false;

    const versionData = versionMap.find((x) => x.key === supportKey);
    if (versionData) {
      const foundFeature = versionData.versionedFeatures.find((x) => x.feature === feature);

      if (foundFeature) {
        const { major, minor, build } = foundFeature.minVersion;

        return compareVersions(currentVersion, `${major}.${minor}.${build}`) >= 0;
      }
    }

    return false;
  };

  return {
    versionMap,
    checkSupport,
  };
};
